import React from 'react';
import ReactImageGalery from 'react-image-gallery';

const ImageGallery = ({ imageGalleryRef, ...props }) => (
  <ReactImageGalery
    additionalClass="image-gallery"
    useTranslate3D={false}
    showPlayButton={false}
    ref={imageGalleryRef}
    {...props}
  />
);

export default ImageGallery;
